import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

function apiBaseUrl() {
  if (process.env.API_BASE_URL) return process.env.API_BASE_URL;
  return '/api';
}

const rawBaseQuery = fetchBaseQuery({ baseUrl: apiBaseUrl() });

function baseQueryWithAuth(args, api, extraOptions) {
  const url = typeof args === 'string' ? args : args.url;
  const isPublic = url.startsWith('/public/');
  const state = api.getState();
  const token = isPublic ? state.subscriberAuth?.token : state.auth?.token;

  const preparedArgs = typeof args === 'string' ? { url: args } : { ...args };
  if (token) {
    preparedArgs.headers = { ...preparedArgs.headers, authorization: `Bearer ${token}` };
  }
  return rawBaseQuery(preparedArgs, api, extraOptions);
}

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    'Organization',
    'EmailDomain',
    'User',
    'Group',
    'PublicGroup',
    'Subscriber',
    'Giveaway',
    'ScheduledAlert',
    'ScheduledNotification',
    'GroupMessage',
    'Request',
    'GroupDeliveries',
  ],
  endpoints: () => ({}),
});
